import React, { useState, useEffect, useMemo, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/actions/index";
import OnboardingModal from "../../Utils/dialogs/OnboardingModal";
import "./indeterminateCheckbox.css";
import styled from "styled-components";
import { useTable, useRowSelect, useSortBy, useFilters } from "react-table";
import urlLinks from "../../UrlLinks";
import Axios from "axios";
import styles from "./index.module.scss";
import Pagination from "../../Utils/Pagination";
import * as moment from "moment";
import NoRecord from "./Assets/noRecord.svg";
import ScaleLoader from "react-spinners/ScaleLoader";
import { AuthContext } from "../../services/AuthProvider";
import UrlLinks from "../../UrlLinks";
import ExportButton from "../../Utils/functions/ExportButton";
import RemoveExtraSpaces from "../../Utils/functions/RemoveExtraSpaces";
import SearchBar from "../../Utils/functions/SearchBar";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Drawer, Button } from "@material-ui/core";
import JobFilter from "../../Utils/FilterComponents/JobFilter";
import filterIcon from "../../assets/filterIcon.svg";
import FilterIconMarked from "../../assets/FilterIconMarked.svg";
import FilterDrawer from "./components/FilterDrawer";
import DocumentDownload from "./components/downloadDocuments";
import ProfileVerification from "../../Utils/dialogs/ProfileVerification";
import { makeDynamicStatus } from "../../Utils/functions/DynamicStatus";
import { AppData } from "../../context/context";
import { replaceExtension } from "../../Utils/CommonFunctions";
import { trackEvent, FE_EVENTS } from '../../Utils/analytics';

const Styles = styled.div`
  padding: 1rem;
  .tableContainer {
    overflow-x: scroll;
    border: 1px solid #cfcfcf;
    border-radius: 5px;
    max-height: 74vh;
  }
  .tableContainer::-webkit-scrollbar {
    width: 0.75em;
  }

  .tableContainer::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  .tableContainer::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
  table {
    border-spacing: 0;
    width: max-content;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th {
      :last-child {
        border-left: 0;
      }
      background-color: #1c4980;
      color: #ffffff;
    }
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #cfcfcf;
      background-color: white;
      nth-last-child(2) {
        border-right: 0;
      }
      :last-child {
        border-right: 0;
      }

      input {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        border: 0;
      }
    }
  }

  .pagination {
    padding: 0.5rem;
  }
`;

const useStyles = makeStyles((theme) => ({}));

const AttendanceManagement = (props) => {
  /** accessing states from redux store **/

  const { users, applicationDb } = useSelector((state) => state);
  const {
    loader,
    currentPage,
    perPage,
    totalRows,
    totalPages,
    openFilterDrawer,
    isFilter,
    allRecord,
  } = users;
  const { curLeadId } = applicationDb;

  /** useDispatch is used to update states to redux store **/

  const dispatch = useDispatch();
  const {
    setLoader,
    setCurrentPage,
    setPerPage,
    setTotalRows,
    setTotalPages,
    setSelectedAssignIds,
    setSelectedUserIds,
    setOpenFilterDrawer,
    setIsFilter,
    setAllRecord,
    setModalLoader,
  } = bindActionCreators(actionCreators, dispatch);

  /** other states **/

  const classes = useStyles();
  const { showToast } = useContext(AuthContext);
  const { userAction } = useContext(AppData);
  const [data, setData] = useState([]);
  const [allRecordLoading, setAllRecordLoading] = useState(false);
  const [searchByAuto, setSearchByAuto] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [filterUrl, setFilterUrl] = useState("");
  const [selfieLoader, setSelfieLoader] = useState(null);
  const [searchError, setSearchError] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [openMpaModal, setOpenMpaModal] = useState(false);
  const [leadCityId, setLeadCityId] = useState(() => {
    const storedCityIds = localStorage.getItem("leadCityIdArray");
    return storedCityIds ? JSON.parse(storedCityIds) : [];
  });
  const [openSelfieVerificationModal, setOpenSelfieVerificationModal] =
    useState(false);
  const [selfieVerificationList, setSelfieVerificationList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(() => {
    const storedFilters = localStorage.getItem("attendanceProjectFilter");
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          id: "",
          name: "Change Project",
        };
  });

  const [selectedTime, setSelectedTime] = useState(() => {
    const storedFilters = localStorage.getItem("attendanceFilter");
    return storedFilters
      ? JSON.parse(storedFilters)["attendanceTime"]
      : [null, null];
  });

  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem("attendanceFilter");
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          attendanceDate: [null, null],
          attendanceTime: [null, null],
          city: "",
          projectId: selectedOption.id,
          searchBy: "",
          selfieVerificationStatus: "",
        };
  });

  const resetFiltersWithoutSearch = () => {
    setIsFilter(false);
    const filterList = {
      attendanceDate: [null, null],
      attendanceTime: [null, null],
      city: "",
      projectId: filters.projectId,
      searchBy: filters.searchBy,
      selfieVerificationStatus: "",
    };

    if (openFilterDrawer) {
      setFilterUrl(
        `${filters.searchBy ? "&searchBy=" + filters.searchBy : ""}${
          filters.projectId ? "&projectId=" + filters.projectId : ""
        }`
      );
    }

    setFilters(filterList);
    setSelectedTime([null, null]);
    setLeadCityId([]);
    setCurrentPage(1);
    setOpenFilterDrawer(false);
    return filterList;
  };

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        columns: [
          {
            id: "dateId",
            accessor: "checkinDate",
            Cell: (row) => {
              return (
                <div>
                  {row.row.original.checkinDate
                    ? moment(row.row.original.checkinDate).format("DD/MM/YYYY")
                    : "-"}
                </div>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "OkayGo ID",
        columns: [
          {
            id: "okaygoId",
            accessor: "okaygoId",
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Name",
        columns: [
          {
            id: "nameId",
            accessor: "firstName",
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Phone No",
        columns: [
          {
            id: "phoneNoId",
            accessor: "phoneNumber",
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Check In Time",
        columns: [
          {
            id: "checkinTimeId",
            accessor: "checkinTime",
            Cell: (row) => {
              return (
                <div>
                  {row.row.original.checkinTime
                    ? moment(row.row.original.checkinTime, "HH:mm:ss").format(
                        "h:mm A"
                      )
                    : "-"}
                </div>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Check Out Time",
        columns: [
          {
            id: "checkoutTimeId",
            accessor: "checkoutTime",
            Cell: (row) => {
              return (
                <div>
                  {row.row.original.checkoutTime
                    ? moment(row.row.original.checkoutTime, "HH:mm:ss").format(
                        "h:mm A"
                      )
                    : "-"}
                </div>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Location",
        columns: [
          {
            id: "locationId",
            accessor: "checkinLocation",
            Cell: (row) => {
              return (
                <div style={{ width: "561px" }}>
                  {row.row.original.checkinLocation}
                </div>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Start Time Selfie",
        columns: [
          {
            id: "selfieId",
            accessor: "selfieLink",
            Cell: (props) => (
              <DocumentDownload {...props} uniqueId="selfieId" />
            ),
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "End Time Selfie",
        columns: [
          {
            id: "checkoutSelfieLinkId",
            accessor: "checkoutSelfieLink",
            Cell: (props) => (
              <DocumentDownload {...props} uniqueId="checkoutSelfieLinkId" />
            ),
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Source",
        columns: [
          {
            id: "sourceId",
            accessor: "source",
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Overtime Date & Time",
        columns: [
          {
            id: "overtimeDateId",
            accessor: "overtimeDate",
            Cell: (row) => {
              return (
                <div>
                  {row.row.original.overtimeDate
                    ? `${moment(row.row.original.overtimeDate).format(
                        "DD/MM/YYYY"
                      )},`
                    : ""}
                  {"  "}
                  {row.row.original.overtime
                    ? moment(row.row.original.overtime, "HH:mm:ss").format(
                        "h:mm A"
                      )
                    : "-"}
                </div>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Overtime Selfie",
        columns: [
          {
            id: "overtimeSelfieLinkId",
            accessor: "overtimeSelfieLink",
            Cell: (props) => (
              <DocumentDownload {...props} uniqueId="overTime" />
            ),
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
      {
        Header: "Time Slot",
        columns: [
          {
            id: "shift1",
            Header: "Time Shift 1",
            accessor: "slot1",
            Cell: (row) => {
              const slot1Object = JSON.parse(row.row.original.slot1);
              return (
                <div>
                  {slot1Object
                    ? slot1Object?.checkinTime
                      ? moment(slot1Object.checkinTime, "HH:mm:ss").format(
                          "h:mm A"
                        )
                      : "Not marked"
                    : "-"}
                </div>
              );
            },
          },
          {
            id: "shift2",
            Header: "Time Shift 2",
            accessor: "slot2",
            Cell: (row) => {
              const slot2Object = JSON.parse(row.row.original.slot2);
              return (
                <div>
                  {slot2Object
                    ? slot2Object?.checkinTime
                      ? moment(slot2Object.checkinTime, "HH:mm:ss").format(
                          "h:mm A"
                        )
                      : "Not marked"
                    : "-"}
                </div>
              );
            },
          },
          {
            id: "shift3",
            Header: "Time Shift 3",
            accessor: "slot3",
            Cell: (row) => {
              const slot3Object = JSON.parse(row.row.original.slot3);
              return (
                <div>
                  {slot3Object
                    ? slot3Object?.checkinTime
                      ? moment(slot3Object.checkinTime, "HH:mm:ss").format(
                          "h:mm A"
                        )
                      : "Not marked"
                    : "-"}
                </div>
              );
            },
          },
          {
            id: "shift4",
            Header: "Time Shift 4",
            accessor: "slot4",
            Cell: (row) => {
              const slot4Object = JSON.parse(row.row.original.slot4);
              return (
                <div>
                  {slot4Object
                    ? slot4Object?.checkinTime
                      ? moment(slot4Object.checkinTime, "HH:mm:ss").format(
                          "h:mm A"
                        )
                      : "Not marked"
                    : "-"}
                </div>
              );
            },
          },
          {
            id: "shift5",
            Header: "Time Shift 5",
            accessor: "slot5",
            Cell: (row) => {
              const slot5Object = JSON.parse(row.row.original.slot5);
              return (
                <div>
                  {slot5Object
                    ? slot5Object?.checkinTime
                      ? moment(slot5Object.checkinTime, "HH:mm:ss").format(
                          "h:mm A"
                        )
                      : "Not marked"
                    : "-"}
                </div>
              );
            },
          },
        ],
      },
      {
        Header: "Selfie verification",
        columns: [
          {
            id: "selfieVerificationId",
            accessor: "selfieVerification",
            Cell: (row) => {
              return (
                <Grid container style={{ display: "flex", width: "200px" }}>
                  <Grid item xs={8}>
                    {makeDynamicStatus(
                      "selfieVerification",
                      row.row.original.isVerified
                    )}
                  </Grid>
                  {row.row.original.isVerified !== 3 && (
                    <Grid item xs={4} style={{ display: "flex" }}>
                      <button
                        className={styles.viewButton}
                        type="button"
                        onClick={(e) =>
                          handleClick(
                            e,
                            -1,
                            "selfieVerification",
                            row.row.original
                          )
                        }
                      >
                        <span style={{ textDecoration: "underline" }}>
                          View
                        </span>{" "}
                        <span>{">"}</span>
                      </button>
                    </Grid>
                  )}
                </Grid>
              );
            },
            defaultCanFilter: false,
            defaultCanSort: false,
          },
        ],
      },
    ],
    [selectedOption]
  );

  // Function to update the Table Data
  const updateMyData = () => {
    getExternalWorkerList(perPage, currentPage);
  };

  const handleSelfieDownload = (selfieUrl, data) => {
    setSelfieLoader(data.attendanceId);
    // const isLocal = window.location.hostname === "localhost";
    // if (selfieUrl.startsWith("http://")) {
    //   selfieUrl = isLocal
    //     ? selfieUrl
    //     : "https" + selfieUrl.substring(4, selfieUrl.length);
    // }
    fetch(selfieUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectURL;
        const dateFormat = moment(data.checkinDate)
          .format("DD/MM/YYYY")
          .replace(/_/g, "/");
        link.download = `${data.firstName}_${data.okaygoId}_${dateFormat}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setSelfieLoader(null);
      });
  };

  const handleClick = async (event, index, type, rowData) => {
    switch (type) {
      case "attendanceTimeFrom":
        setSelectedTime([event, selectedTime[1]]);
        setFilters({
          ...filters,
          attendanceTime: [
            moment(event, "ddd MMM DD YYYY HH:mm:ss ZZ").format("HH:mm:ss"),
            filters.attendanceTime[1],
          ],
        });
        break;
      case "attendanceTimeTo":
        setSelectedTime([selectedTime[0], event]);
        setFilters({
          ...filters,
          attendanceTime: [
            filters.attendanceTime[0],
            moment(event, "ddd MMM DD YYYY HH:mm:ss ZZ").format("HH:mm:ss"),
          ],
        });
        break;
      case "selfieVerification":
        setModalLoader(true);
        setOpenSelfieVerificationModal(true);
        await Axios.get(
          `${UrlLinks.baseUrl}${UrlLinks.projectListing.getAttendanceSelfieVerificationListing}?attendanceId=${rowData.attendanceId}`
        )
          .then((res) => {
            setSelfieVerificationList(res.data.response);
          })
          .catch((err) => {
            console.log("err", err);
            showToast(
              "error",
              "Error",
              "Something went wrong, please try after sometime."
            );
          });
        setModalLoader(false);
        break;
      default:
        break;
    }
  };

  const handleSearch = () => {
    trackEvent(FE_EVENTS.ATTENDANCE_SEARCH);
    setFilters((prev) => ({ ...prev, searchBy }));
    setSearchByAuto(searchBy);
  };

  const handleSearchClose = () => {
    setFilters((prev) => ({ ...prev, searchBy: "" }));
    setSearchBy("");
    setSearchByAuto("");
    window.location.reload();
  };

  const updateFilterUrl = () => {
    let url = "";

    // Search By
    if (filters["searchBy"] !== "") {
      url = `${url}&searchBy=${filters["searchBy"]}`;
    }

    // Date
    if (filters["attendanceDate"][0] && !filters["attendanceDate"][1])
      url = `${url}&dateFrom=${moment(filters["attendanceDate"][0]).format(
        "YYYY-MM-DD"
      )}&dateTo=${moment(new Date()).format("YYYY-MM-DD")} 23:59:59`;
    if (!filters["attendanceDate"][0] && filters["attendanceDate"][1])
      url = `${url}&dateFrom=2019-01-01&dateTo=${moment(
        filters["attendanceDate"][1]
      ).format("YYYY-MM-DD")} 23:59:59`;
    if (filters["attendanceDate"][0] && filters["attendanceDate"][1])
      url = `${url}&dateFrom=${moment(filters["attendanceDate"][0]).format(
        "YYYY-MM-DD"
      )}&dateTo=${moment(filters["attendanceDate"][1]).format(
        "YYYY-MM-DD"
      )} 23:59:59`;

    // Time
    if (filters["attendanceTime"][0] && !filters["attendanceTime"][1])
      url = `${url}&timeFrom=${filters.attendanceTime[0].toString()}`;
    if (!filters["attendanceTime"][0] && filters["attendanceTime"][1])
      url = `${url}&timeTo=${filters.attendanceTime[1].toString()}`;
    if (filters["attendanceTime"][0] && filters["attendanceTime"][1])
      url = `${url}&timeFrom=${filters.attendanceTime[0].toString()}&timeTo=${filters.attendanceTime[1].toString()}`;

    // City
    if (filters["city"]) {
      url = `${url}&city=${filters["city"]}`;
    }

    if (filters["projectId"]) {
      url = `${url}&projectId=${filters["projectId"]}`;
    }

    // Selfie Verification Status
    if (filters["selfieVerificationStatus"]) {
      url = `${url}&verificationStatus=${filters["selfieVerificationStatus"].id}`;
    }

    return url;
  };

  const ApplyFilters = () => {
    let url = updateFilterUrl();
    setFilterUrl(url);
    setFilters(filters);
    setCurrentPage(1);
  };

  //Function to create export data as per the main listing order
  const makeAttendanceExportData = (response) => {
    let extractedData = [];

    response.map((el) => {
      const slot1Object = JSON.parse(el.slot1);
      const slot2Object = JSON.parse(el.slot2);
      const slot3Object = JSON.parse(el.slot3);
      const slot4Object = JSON.parse(el.slot4);
      const slot5Object = JSON.parse(el.slot5);

      extractedData.push({
        Date: el.checkinDate ? moment(el.checkinDate).format("DD/MM/YYYY") : "",
        OkaygoId: el.okaygoId || "",
        Name: el.firstName || "",
        PhoneNo: el.phoneNumber || "",
        "Check In Time": el.checkinTime
          ? moment(el.checkinTime, "HH:mm:ss").format("h:mm A")
          : "",
        "Check Out Time": el.checkoutTime
          ? moment(el.checkoutTime, "HH:mm:ss").format("h:mm A")
          : "",
        Address: el.checkinLocation || "",
        "Start Time Selfie": el.selfieLink
          ? replaceExtension(el.selfieLink)
          : "",
        "End Time Selfie": el.checkoutSelfieLink
          ? replaceExtension(el.checkoutSelfieLink)
          : "",
        Source: el.source || "",
        "Overtime Date":
          !moment(el.overtimeDate).format("DD/MM/YYYY").includes("Invalid") &&
          el.overtimeDate
            ? moment(el.overtimeDate).format("DD/MM/YYYY")
            : "",
        "Overtime Time": el.overtime
          ? moment(el.overtime, "HH:mm:ss").format("h:mm A")
          : "",
        "Overtime Selfie": el.overtimeSelfieLink
          ? replaceExtension(el.overtimeSelfieLink)
          : "",
        "Slot 1": slot1Object
          ? slot1Object.checkinTime
            ? moment(slot1Object.checkinTime, "HH:mm:ss").format("h:mm A")
            : "Not Marked"
          : "",
        "Slot 2": slot2Object
          ? slot2Object.checkinTime
            ? moment(slot2Object.checkinTime, "HH:mm:ss").format("h:mm A")
            : "Not Marked"
          : "",
        "Slot 3": slot3Object
          ? slot3Object.checkinTime
            ? moment(slot3Object.checkinTime, "HH:mm:ss").format("h:mm A")
            : "Not Marked"
          : "",
        "Slot 4": slot4Object
          ? slot4Object.checkinTime
            ? moment(slot4Object.checkinTime, "HH:mm:ss").format("h:mm A")
            : "Not Marked"
          : "",
        "Slot 5": slot5Object
          ? slot5Object.checkinTime
            ? moment(slot5Object.checkinTime, "HH:mm:ss").format("h:mm A")
            : "Not Marked"
          : "",
        "Selfie verification":
          el.isVerified === 0
            ? "Flagged"
            : el.isVerified === 1
            ? "Verified"
            : el.isVerified === 2
            ? "Rejected"
            : el.isVerified === 3
            ? "Not Filled"
            : "",
        ...el.attributeResponses,
      });
      return true;
    });
    return extractedData;
  };

  //Function to call export data
  const createAllRecordExcel = async () => {
    trackEvent(FE_EVENTS.ATTENDANCE_EXPORT);
    setAllRecordLoading(true);
    let excelExportedBy = `&export=1`;

    Axios.get(
      `${urlLinks.baseUrl}${urlLinks.projectListing.getAttendanceByProjectId}?${excelExportedBy}${filterUrl}`
    )
      .then((response) => {
        if (response) {
          setAllRecord(makeAttendanceExportData(response.data.response));
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  //Function to call main listing.
  const getExternalWorkerList = async (rows, pageNo) => {
    setAllRecord([]);
    if (localStorage.getItem("roleType")) {
      setLoader(true);

      let mainUrl = `${urlLinks.baseUrl}${
        urlLinks.projectListing.getAttendanceByProjectId
      }?page_no=${pageNo - 1}&rows=${rows}${filterUrl}`;

      try {
        if (
          selectedOption.id &&
          localStorage.getItem("attendanceProjectFilter") &&
          filterUrl.includes("projectId")
        ) {
          const response = await Axios.get(mainUrl);
          if (response) {
            setTotalRows(response.data.response?.totalElements);
            setTotalPages(response.data.response?.totalPages);
            if (currentPage > response.data.response?.totalPages) {
              setCurrentPage(1);
            }
            setData(
              response.data.response ? response.data.response.content : []
            );
          }
        }
        setLoader(false);
      } catch (error) {
        if (Axios.isCancel(error)) {
          console.log("Request canceled:", error.message);
        } else {
          console.error("Error:", error);
          setLoader(false);
        }
      }
    }
  };

  const handlePageChange = (page) => {
    getExternalWorkerList(perPage, page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    getExternalWorkerList(newPerPage, 1);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const makeProjectList = (data) => {
    let list = [];
    // const projectIdsArray = localStorage.getItem("projectId").split(",");
    const projectIdsArray1 = ["67"]; //coded for Mettl Invigilation Checklist
    const projectIdsArray2 = ["86", "127"]; //projects for client Swiggy IRCTC

    data.map((el) => {
      if (localStorage.getItem("roleType") === "23") {
        let isIdPresent = projectIdsArray1.includes(el.projects_id.toString());
        if ((el.attendance == 1 || el.attendance_history == 1) && isIdPresent) {
          list.push({
            id: el.projects_id,
            name: el.project_name,
            partner_id: el.partner_id,
          });
        }
      } else if (localStorage.getItem("roleType") === "51") {
        let isIdPresent = projectIdsArray2.includes(el.projects_id.toString());
        if ((el.attendance == 1 || el.attendance_history == 1) && isIdPresent) {
          list.push({
            id: el.projects_id,
            name: el.project_name,
            partner_id: el.partner_id,
          });
        }
      } else {
        if (el.attendance == 1 || el.attendance_history == 1) {
          list.push({
            id: el.projects_id,
            name: el.project_name,
            partner_id: el.partner_id,
          });
        }
      }
    });

    if (
      JSON.parse(localStorage.getItem("attendanceProjectFilter"))?.id === ""
    ) {
      setFilters((prev) => ({ ...prev, projectId: list[0]?.id }));
      setSelectedOption({
        id: list[0]?.id,
        name: list[0]?.name,
      });
    }
    return list;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleAllRowsSelected,
    state: { selectedRowIds },
  } = useTable(
    {
      columns,
      data,
      updateMyData,
      handleSelfieDownload,
      selfieLoader,
      showToast,
      setLoader,
      filters,
      setFilters,
      manualSortBy: true,
    },
    useFilters,
    useSortBy,
    useRowSelect
  );

  const table = (
    <div className={`tableContainer ${styles.tableContainer}`}>
      <table {...getTableProps()}>
        <thead className="thead">
          {headerGroups.map((headerGroup, rowIndex) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={rowIndex}>
              {headerGroup.headers.map((column, columnIndex) => {
                return (
                  <th
                    {...column.getHeaderProps()}
                    key={columnIndex}
                    className={
                      column.render("Header") === "Time Slot"
                        ? `header textAlignCenter`
                        : column.render("Header") === "Time Shift 1" ||
                          column.render("Header") === "Time Shift 2" ||
                          column.render("Header") === "Time Shift 3" ||
                          column.render("Header") === "Time Shift 4" ||
                          column.render("Header") === "Time Shift 5"
                        ? `header3 row2HeaderShift`
                        : column.render("Header") === "Name"
                        ? `stickAttendanceWorkerName zIndex1080 header`
                        : column.render("Header")?.props?.column.id === "nameId"
                        ? `stickAttendanceWorkerName zIndex1080 header3`
                        : rowIndex === 0
                        ? "header"
                        : "header3"
                    }
                  >
                    <span style={{ paddingRight: "" }}>
                      {column.render("Header")}
                    </span>
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        {
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={i}>
                  {row.cells.map((cell, j) => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        key={j}
                        className={`${
                          cell.column.id === "nameId"
                            ? `stickAttendanceWorkerName zIndex540`
                            : "cell"
                        }`}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        }
      </table>
    </div>
  );

  /* Useffects */

  useEffect(() => {
    localStorage.setItem("attendanceFilter", JSON.stringify(filters));
  }, [filters]);

  useEffect(() => {
    localStorage.setItem("leadCityIdArray", JSON.stringify(leadCityId));
  }, [leadCityId]);

  useEffect(() => {
    localStorage.setItem(
      "attendanceProjectFilter",
      JSON.stringify(selectedOption)
    );
  }, [selectedOption]);

  useEffect(() => {
    setAllRecordLoading(false);
  }, [allRecord]);

  useEffect(() => {
    if (
      filters.attendanceDate[0] !== null ||
      filters.attendanceDate[1] !== null ||
      filters.attendanceTime[0] !== null ||
      filters.attendanceTime[1] !== null ||
      filters.city !== "" ||
      filters.selfieVerificationStatus !== ""
    ) {
      setIsFilter(true);
    } else {
      setIsFilter(false);
    }
  }, [filterUrl]);

  useEffect(() => {
    if (selectedRowIds) {
      const indexes = Object.values(selectedRowIds);
      indexes.map((id) => {
        if (id) {
          return true;
        }
        return true;
      });

      const indexValues = Object.entries(selectedRowIds);
      let assignIdList = [];
      let userIdList = [];
      indexValues.map((id) => {
        if (id[1]) {
          assignIdList.push(data[parseFloat(id[0])].assignId);
          userIdList.push(data[parseFloat(id[0])].userId);
        }
        return true;
      });
      assignIdList = assignIdList.join(",");
      setSelectedAssignIds(assignIdList);
      setSelectedUserIds(userIdList);
    }
  }, [selectedRowIds]);

  useEffect(() => {
    let searchByVar = RemoveExtraSpaces(searchBy);
    let count = searchByVar.split(/[ ,]+/).length;
    if (count > 100) {
      setSearchError(true);
    } else {
      setSearchError(false);
    }
  }, [searchBy]);

  useEffect(() => {
    ApplyFilters(filters);
  }, [searchByAuto, selectedOption]);

  useEffect(() => {
    const storedFilters = localStorage.getItem("attendanceFilter");
    const storedProjectFilters = localStorage.getItem(
      "attendanceProjectFilter"
    );
    const storedLeadCityId = localStorage.getItem("leadCityIdArray");

    if (storedFilters) {
      setSearchBy(JSON.parse(storedFilters)["searchBy"]);
      setFilters(JSON.parse(storedFilters));
      const parsed = JSON.parse(storedFilters);
      const timeRange = parsed.attendanceTime || [null, null];

      setSelectedTime([
        timeRange[0] ? moment(timeRange[0], "HH:mm:ss").toDate() : null,
        timeRange[1] ? moment(timeRange[1], "HH:mm:ss").toDate() : null,
      ]);
    }
    if (storedProjectFilters) {
      setSelectedOption(JSON.parse(storedProjectFilters));
    }

    if (storedLeadCityId) {
      setLeadCityId(JSON.parse(storedLeadCityId));
    }

    let assignedProjects =
      JSON.parse(localStorage.getItem("projectList")) || [];
    let assignedProjectIds = assignedProjects?.map((proj) => {
      return proj.id;
    });

    // API for Project List
    Axios.get(
      `${UrlLinks.baseUrl}${UrlLinks.projectListing.getProjectsByIds}?${
        localStorage.getItem("roleType") === "6" ||
        localStorage.getItem("roleType") === "31"
          ? ""
          : `projectIds=${assignedProjectIds}`
      }`
    )
      .then((response) => {
        setProjectList(makeProjectList(response.data.response));
      })
      .catch((err) => {
        showToast("error", "Could not able to fetch job listing");
      });
  }, []);

  useEffect(() => {
    getExternalWorkerList(perPage, 1);
    setCurrentPage(1);
  }, [filterUrl, localStorage.getItem("roleType")]);

  const loaderBar = (
    <div style={{ margin: "130px auto" }}>
      <ScaleLoader height={70} width={10} color={"#1c4980"} />
    </div>
  );

  return (
    <Styles>
      <Grid container className="padding2percent">
        <Grid item xs={12} className="flexDisplay marginBottom8">
          <Grid item xs={12} className="flexDisplay">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "15px",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              {localStorage.getItem("roleType") === "23"
                ? "Mettl Invigilation Checklist"
                : selectedOption.id === ""
                ? "Select Project"
                : selectedOption.name}
            </div>
            {localStorage.getItem("roleType") !== "23" && (
              <JobFilter
                uniqueKey="attendanceProject"
                jobFilterOption={""}
                setJobFilterOption={null}
                jobList={projectList}
                disabled={false}
                filters={filters}
                setFilters={setFilters}
                id="projectId"
                statusId="jobStatus"
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
                jobFilterOptionList={[]}
                placeholder="Type or search the jobs"
              />
            )}
            {selectedOption.partnerId == 214 && (
              <div className={styles.tagLocation}>
                <Button
                  variant="outlined"
                  className={`dataButtonOutline2 ${styles.tagLocationButton}`}
                  onClick={() => setOpenMpaModal(true)}
                >
                  Tag Location
                </Button>
              </div>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} className="flexDisplay">
          <Grid
            item
            xs={6}
            className="flexDisplay paddingTop8 justifySpaceBetween"
          >
            <SearchBar
              uniqueId="attendanceConfig"
              searchBy={searchBy}
              setSearchBy={setSearchBy}
              searchError={searchError}
              filters={filters}
              setFilters={setFilters}
              handleSearch={handleSearch}
              handleSearchClose={handleSearchClose}
              ApplyFilters={ApplyFilters}
              setFilterUrl={setFilterUrl}
              placeholder="Search by Contact number/ OkayGo ID"
              buttonName="Search"
              searchInstructions="Use comma or space as delimiter to search multiple OkayGo Id. Max limit 100."
              warningMessage=" Max limit reached. Search 100 pin max."
            />
          </Grid>
          <Grid item xs={6} className={`${styles.itemRowReverse} flexDisplay`}>
            <button
              className={styles.filterButton}
              style={{ marginLeft: "16px" }}
              onClick={() => setOpenFilterDrawer(true)}
            >
              {!isFilter ? (
                <img src={filterIcon} alt="filterIcon" />
              ) : (
                <img src={FilterIconMarked} alt="filterIcon" />
              )}
              Filters
            </button>
            {!!userAction.export_access && (
              <ExportButton
                uniqueKey="AttendanceConfig"
                createAllRecordExcel={createAllRecordExcel}
                allRecordLoading={allRecordLoading}
                filename="Attendance Management.csv"
                buttonName="Export to Excel"
                loadingMessage="Please wait ... it might take few minutes."
                downloadButton="Download now"
              />
            )}
          </Grid>
        </Grid>
        {loader ? (
          loaderBar
        ) : data.length === 0 ? (
          <div className={styles.noRecord}>
            <img src={NoRecord} alt="noRecord" />
            <span>No records found</span>
          </div>
        ) : (
          <Grid item xs={12} className="paddingTop16">
            {table}
            <Pagination
              rowsperpage={perPage}
              pageNo={currentPage}
              totalElements={totalRows}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
            />
          </Grid>
        )}
        {openMpaModal && (
          <OnboardingModal
            openOnboardingModal={openMpaModal}
            setOpenOnboardingModal={setOpenMpaModal}
            showToast={showToast}
            updateMyData={updateMyData}
            title="Tag Location"
            uniqueKey="tagLocation"
            templateButton="Download File Template"
            url={`${UrlLinks.baseUrl}${
              UrlLinks.workerUrls.uploadTcsAllotment
            }?insertedBy=${localStorage.getItem("userID")}`}
            fileName="Invalid MPA data"
          />
        )}
        {openFilterDrawer && (
          <Drawer
            anchor="right"
            open={openFilterDrawer}
            onClose={() => {
              setLeadCityId(curLeadId.leadCity);
              setOpenFilterDrawer(false);
            }}
          >
            <FilterDrawer
              handleClose={() => setOpenFilterDrawer(false)}
              filters={filters}
              setFilters={setFilters}
              ApplyFilters={ApplyFilters}
              leadCityId={leadCityId} // retained array <---
              setLeadCityId={setLeadCityId}
              resetFilters={resetFiltersWithoutSearch}
              handleChange={handleClick}
              selectedTime={selectedTime}
            ></FilterDrawer>
          </Drawer>
        )}
        <ProfileVerification
          uniqueKey="selfieVerification"
          open={openSelfieVerificationModal}
          setOpen={setOpenSelfieVerificationModal}
          title={`Selfie Verification`}
          dataList={selfieVerificationList}
          leftPicName="Attendance Selfie"
          rightPicName="Profile photo"
          leftPicLink={selfieVerificationList.attendanceSelfie}
          rightPicLink={selfieVerificationList.profilePhoto}
          showToast={showToast}
          updateMyData={updateMyData}
        />
      </Grid>
    </Styles>
  );
};

export default AttendanceManagement;

